export default __webpack_public_path__ + "static/media/egg.e088c4c9.png";